import script from "./AdminSessionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSessionTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminSessionTable.vue?vue&type=style&index=0&id=aac8cf28&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aac8cf28"]])

export default __exports__